"use client"
import ButtonNF from "@/app/ui/forms/ButtonNF"
import { cn } from "@/lib/utils"
import { useSession } from "next-auth/react"
import Link from "next/link"
import { usePathname } from "next/navigation"
import { MdAdminPanelSettings } from "react-icons/md"

function NightfallPanelBtn({ className }: { className?: string }) {
    const session = useSession();
    const isNfMember = session.data?.user.nfMember;
    const pathname = usePathname()
    const isHidden = pathname == "/nfMembers";

    const showBtn = isNfMember && !isHidden;
    return <Link href={ showBtn && "/nfMembers" || "" } className={ cn(className,
        "btn duration-300 transition-[grid-template-columns] ease-out",
        "grid-cols-[0fr]",
        //
        showBtn && "grid-cols-[1fr]") }>
        {
            showBtn &&
            <ButtonNF color="gold" className="overflow-hidden w-full"
                onClick={
                    () => {
                        const menuToggler = document.getElementById("menuToggle");
                        if (menuToggler)
                            (menuToggler as HTMLInputElement).checked = false;
                    } }>
                <MdAdminPanelSettings className="inline-block" /> פאנל
            </ButtonNF>
        }
    </Link>
}
export default NightfallPanelBtn